import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { WeatherBonusOrchestratorService } from 'src/app/core/helpers/weather-bonus-orchestrator.service';

@Component({
  selector: 'loyaltic-confirm-receipt-upload',
  templateUrl: './confirm-receipt-upload.component.html',
  styleUrls: ['./confirm-receipt-upload.component.scss']
})
export class ConfirmReceiptUploadComponent implements OnInit {

  @ViewChild('confirmReceiptUpload', { static: false }) confirmReceiptUploadRef: any;
  @ViewChild('thankyouNotApprovedPopup', { static: false }) thankyouNotApprovedPopupRef: any;

  userId = '';
  receiptNotApprovedData: any;
  IsUserAlreadyLoggedIn = false;
  reasons:any = [];

  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  confirmPopupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc modal-md modal-dialog-centered',
  };


  constructor( private modalService: BsModalService,
    private dataService:DataServiceService,
     private router: Router,
     private authService: AuthService,
     private coreService: CoreService,
     private gaService: GaService,
     private weatherBonusOrchestrator: WeatherBonusOrchestratorService
     ) {
      this.userId = this.authService.getUserId();
      if (this.userId) {
        this.IsUserAlreadyLoggedIn = true;
      }
  }

  ngOnInit() {
    this.receiptNotApprovedData = this.dataService.getReceiptNotApprovedData();
    console.log('[confirm-receipt-upload] receiptNotApprovedData', this.receiptNotApprovedData);
    this.reasons = this.buildReasons();
    console.log("========reasosn", this.reasons)
  }

  private buildReasons() {
    const feedbackMessages = this.receiptNotApprovedData && this.receiptNotApprovedData.feedbackMessages
      ? this.receiptNotApprovedData.feedbackMessages
      : [];

    const codeMap: { [key: string]: string } = {
      'productFound': 'receipt_scan_product_not_found',
      'dateValid': 'receipt_scan_date_invalid',
      'notDuplicate': 'receipt_scan_duplicate_found',
      'totalValid': 'receipt_scan_total_invalid',
      'currencyValid': 'receipt_scan_currency_invalid'
    };

    if (feedbackMessages.length > 0) {
      return feedbackMessages
      .filter((item: any) => !item.passed)
      .map((item: any) => ({
        key: item.code,
        translateCode: codeMap[item.code] || `receipt_scan_${item.code.toLowerCase()}_invalid`,
        value: item.passed,
        message: item.message
      }));
    }

    const scanningData:any[] = this.coreService.rejectedReasons;
    // Hardcoded reasons for demonstration, adjust as needed based on actual `scanningData` values
    return [
      {
        label: 'Product found',
        translateCode: 'receipt_scan_product_not_found',
        value: scanningData.indexOf('product-not-found') === -1
      },
      {
        label: 'Date valid',
        translateCode: 'receipt_scan_date_invalid',
        value: scanningData.indexOf('invalid-purchase-date-time') === -1
      },
      {
        label: 'Receipt valid',
        translateCode: 'receipt_scan_duplicate_found',
        value: scanningData.indexOf('potential-duplicate-receipt') === -1
      }
    ].filter((item: any) => !item.value);
  }

  onReceiptConfirm() {
    this.coreService.confirmReceiptUpload(this.receiptNotApprovedData.recptPartitionKey, this.receiptNotApprovedData.recptRowKey)
      .then(async (response: any) => {
        if (response && response.result && response.result.isAiApproved) {
          await this.weatherBonusOrchestrator.applyFromUploadResult({ ...response.result, isapproved: true });
        }
        this.modalRef.hide();
        localStorage.removeItem('productList')
        this.gaService.emitEvent('upload_receipt', 'upload_receipt');
        // this.gaService.conversionEmitter("playWithReceipt");
        if (this.IsUserAlreadyLoggedIn) {
          // this.gtmService.pushTag({ event: 'PlayType', status: 'Play with receipt' });
          this.gaService.emitEvent('login', 'success');
          //this.resetForm();
          localStorage.setItem('isWithFlow', '1');
          this.gaService.emitEvent('upload_receipt', 'success');
          this.modalRef = this.modalService.show(this.thankyouNotApprovedPopupRef, this.confirmPopupConfig);
        } else {
          this.gaService.emitEvent('login', 'uploadReceipt');
          // this.resetForm();
          const result = response.result;
          this.authService.setToken(this.receiptNotApprovedData.token, this.receiptNotApprovedData.id);
          localStorage.setItem('isWithFlow', '1');
          this.gaService.emitEvent('upload_receipt', 'success');
          this.modalRef = this.modalService.show(this.thankyouNotApprovedPopupRef, this.confirmPopupConfig);
        }
      });
  }


  ngAfterViewInit() {
    this.modalRef = this.modalService.show(this.confirmReceiptUploadRef, this.popupConfig);

  }

  hideModal() {
    this.modalRef.hide();
    //this.router.navigate([this.router.url])
    this.router.navigate( [this.router.url], {fragment: 'uploadDiv'});
  }
}
